import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  UncontrolledDropdown,
  Row,
  Nav,
} from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { profileLinks } from '../../../../config/profileUrls';
import {requestLogOut} from "../../../../store/actions/user";

class DesktopComponent extends Component {
  render() {
    return (
      <Nav className="align-items-center ml-auto ml-md-0" navbar>
        <UncontrolledDropdown nav>
          <Row className="align-items-top">
            <DropdownToggle className="nav-link pr-0 d-inline-block cursor-pointer" color="" tag="a">
              <span className="avatar avatar-sm rounded-circle">
                <img
                  onError={ this.props.addDefaultSrc }
                  alt={ `Avatar` }
                  src={ require('../../../../assets/images/default-avatar.png') }
                />
              </span>
            </DropdownToggle>
            <DropdownToggle className="nav-link pr-0 pl-0 d-none d-lg-inline-block cursor-pointer header-profile-container" tag="a">
              <Media>
                <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold header-profile-container">
                    </span>
                </Media>
              </Media>
            </DropdownToggle>
          </Row>
          <DropdownMenu right>
            <DropdownItem className="noti-title" header tag="div">
              <h6 className="text-overflow m-0">
                <FormattedMessage id="components.layout.navbars.profileDropdown.welcome" />
              </h6>
            </DropdownItem>
            {
              this.props.profileLinks.map((link, key) => (
                <DropdownItem
                  key={ key }
                  href={ link.href }
                  onClick={ link.onClick }
                  id={ link.id }
                >
                  <i className={ link.icon } />
                  <span>
                    <FormattedMessage id={ link.name } />
                  </span>
                </DropdownItem>
              ))
            }
            <DropdownItem divider />
            <DropdownItem
              id="logout-btn"
              href="#pablo"
              onClick={
                event => {
                  event.preventDefault();
                  this.props.requestLogOut();
                }
              }
            >
              <i className="ni ni-user-run" />
              <span>
                <FormattedMessage id="app.login.logout_button" />
              </span>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </Nav>
    )
  }
}

DesktopComponent.defaultProps = {
  profileLinks: profileLinks,
  sidenavOpen: false,
  requestLogOut: () => console.log('requestLogOut'),
};

const mapStateToProps = state => ({
});

const mapActionsToProps = {
  requestLogOut,
};

const Desktop = connect(mapStateToProps, mapActionsToProps)(DesktopComponent);

export { Desktop, DesktopComponent };


